"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmount = void 0;
const sdk_core_1 = require("@multiversx/sdk-core");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const constants_1 = require("../constants");
const stringIsInteger_1 = require("./stringIsInteger");
const pipe_1 = require("./pipe");
bignumber_js_1.default.config({ ROUNDING_MODE: bignumber_js_1.default.ROUND_FLOOR });
function formatAmount({ input, decimals = constants_1.DECIMALS, digits = constants_1.DIGITS, showLastNonZeroDecimal = true, showIsLessThanDecimalsLabel = false, addCommas = false }) {
    if (!(0, stringIsInteger_1.stringIsInteger)(input, false)) {
        throw new Error('Invalid input');
    }
    const isNegative = new bignumber_js_1.default(input).isNegative();
    let modInput = input;
    if (isNegative) {
        // remove - at start of input
        modInput = input.substring(1);
    }
    return ((0, pipe_1.pipe)(modInput)
        // format
        .then(() => sdk_core_1.TokenTransfer.fungibleFromBigInteger('', modInput, decimals)
        .amountAsBigInteger.shiftedBy(-decimals)
        .toFixed(decimals))
        // format
        .then((current) => {
        const bnBalance = new bignumber_js_1.default(current);
        if (bnBalance.isZero()) {
            return constants_1.ZERO;
        }
        const balance = bnBalance.toString(10);
        const [integerPart, decimalPart] = balance.split('.');
        const bNdecimalPart = new bignumber_js_1.default(decimalPart || 0);
        const decimalPlaces = (0, pipe_1.pipe)(0)
            .if(Boolean(decimalPart && showLastNonZeroDecimal))
            .then(() => Math.max(decimalPart.length, digits))
            .if(bNdecimalPart.isZero() && !showLastNonZeroDecimal)
            .then(0)
            .if(Boolean(decimalPart && !showLastNonZeroDecimal))
            .then(() => Math.min(decimalPart.length, digits))
            .valueOf();
        const shownDecimalsAreZero = decimalPart &&
            digits >= 1 &&
            digits <= decimalPart.length &&
            bNdecimalPart.isGreaterThan(0) &&
            new bignumber_js_1.default(decimalPart.substring(0, digits)).isZero();
        const formatted = bnBalance.toFormat(decimalPlaces);
        const formattedBalance = (0, pipe_1.pipe)(balance)
            .if(addCommas)
            .then(formatted)
            .if(Boolean(shownDecimalsAreZero))
            .then((current) => {
            const integerPartZero = new bignumber_js_1.default(integerPart).isZero();
            const [numericPart, decimalSide] = current.split('.');
            const zeroPlaceholders = new Array(digits - 1).fill(0);
            const zeros = [...zeroPlaceholders, 0].join('');
            const minAmount = [...zeroPlaceholders, 1].join(''); // 00..1
            if (!integerPartZero) {
                return `${numericPart}.${zeros}`;
            }
            if (showIsLessThanDecimalsLabel) {
                return `<${numericPart}.${minAmount}`;
            }
            if (!showLastNonZeroDecimal) {
                return numericPart;
            }
            return `${numericPart}.${decimalSide}`;
        })
            .if(Boolean(!shownDecimalsAreZero && decimalPart))
            .then((current) => {
            const [numericPart] = current.split('.');
            let decimalSide = decimalPart.substring(0, decimalPlaces);
            if (showLastNonZeroDecimal) {
                const noOfZerosAtEnd = digits - decimalSide.length;
                if (noOfZerosAtEnd > 0) {
                    const zeroPadding = Array(noOfZerosAtEnd).fill(0).join('');
                    decimalSide = `${decimalSide}${zeroPadding}`;
                    return `${numericPart}.${decimalSide}`;
                }
                return current;
            }
            if (!decimalSide) {
                return numericPart;
            }
            return `${numericPart}.${decimalSide}`;
        })
            .valueOf();
        return formattedBalance;
    })
        .if(isNegative)
        .then((current) => `-${current}`)
        .valueOf());
}
exports.formatAmount = formatAmount;
//# sourceMappingURL=formatAmount.js.map